import { IAPIRoutes } from "../../../../config";

export const OfflineDeviceRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getOfflineDevicelist: IGetOfflineDevicelistAPI = async (payload) =>
    GET(
      APIRoutes.apiOfflineDevice.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const postDeviceIssue: IPostDeviceIssueAPI = async (payload) => {
    const formData = new FormData();
    formData.append("clinic_id", payload.clinic_id?.toString() ?? "");
    formData.append("device_id", payload.device_id);
    formData.append("room_name", payload.room_name);
    formData.append("issues", payload.issues.join(","));
    formData.append("comments", payload.comments);
    payload.pictures.forEach((picture) => {
      formData.append("images", picture);
    });

    return POST(
      APIRoutes.apiPostDeviceIssue.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      formData,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
        "Content-Type": "multipart/form-data",
      }
    );
  };

  const getAllDevicelistAPI: IGetAllDevicelistAPI = async (payload) =>
    GET(
      APIRoutes.apiAllDevice.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  return {
    getOfflineDevicelist,
    getAllDevicelistAPI,
    postDeviceIssue,
  };
};
